import { Component, OnInit, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {ModalLabelComponent} from '../modal-label/modal-label.component';
import {ExTranslation} from '../../../class/ex/ex-translation';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-label-translation',
    template: `
        <h5 mat-dialog-title>{{ data?.modalTitle }}</h5>
        <div mat-dialog-content>
          @for (translation of translations; track translation; let i = $index) {
            <div class="form-group">
              <label for="translation-{{ i }}">{{translation.locale === "fr" ? "Français" : "English"}}</label>
              <input  class="form-control"  id="translation-{{ i }}"  name="translation-{{ i }}"  [(ngModel)]="translation.label"  required/>
            </div>
          }
        </div>
        <div mat-dialog-actions>
          <button mat-button type="button" [mat-dialog-close]="false">{{ data?.cancel }}</button>
          <button  mat-raised-button  color="primary"  [disabled]="translationNotValide()"  [mat-dialog-close]="translations">{{ data?.confirm }}</button>
        </div>
        `,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalLabelTranslationComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalLabelComponent>>(MatDialogRef);

    public translations: ExTranslation[] = [];

    constructor() {
        if (this.data == undefined || (this.data['translations'] != undefined && this.data['translations'] != null)) {
            this.translations = [...this.data.translations];
        } else {
            environment.translations.map(locale => {
                this.translations.push(
                    new ExTranslation({ locale, label: '' })
                );
            });
        }
    }

    public translationNotValide() {
        let response = false;
        this.translations.map((item: ExTranslation) => {
            if (
                item.label == undefined ||
                item.label == null ||
                item.label == ''
            )
                {response = true;}
        });
        return response;
    }

    ngOnInit() {}
}
